/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */

export const getStaticHtml = (tree) => {
  const contentNode = tree.children.find(i => i.type === 'PARAGRAPH');
  return contentNode ? contentNode.$$html : undefined;
};
